module.exports = __webpack_public_path__ + "img/allergy-egg.185b3413.png";